/**
 * Global Loading Store
 * 管理全局加载状态 (除登录页外的所有页面)
 * 集成超时保护机制
 */

import { defineStore } from 'pinia'
import { GameMessage } from '@/components/GameMessage'

interface LoadingState {
  isLoading: boolean // 是否显示全局 loading
  loadingText: string // loading 提示文本
  timeoutTimer: ReturnType<typeof setTimeout> | null // 超时定时器
}

export const useLoadingStore = defineStore('loading', {
  state: (): LoadingState => ({
    isLoading: false,
    loadingText: '加载中...',
    timeoutTimer: null,
  }),

  actions: {
    /**
     * 显示全局 loading (带超时保护)
     * @param text 可选的提示文本
     * @param timeout 超时时间(毫秒),默认10秒,设为0则不启用超时
     * @param onTimeout 超时回调函数
     */
    show(text = '加载中...', timeout = 10000, onTimeout?: () => void) {
      // 先清除之前的定时器
      this.clearTimer()

      this.isLoading = true
      this.loadingText = text

      // 如果设置了超时时间,启动超时定时器
      if (timeout > 0) {
        this.timeoutTimer = setTimeout(() => {
          this.hide()

          // 执行超时回调或显示默认错误提示
          if (onTimeout) {
            onTimeout()
          } else {
            GameMessage.info('操作超时,请重试')
          }
        }, timeout)
      }
    },

    /**
     * 隐藏全局 loading
     */
    hide() {
      this.clearTimer()
      this.isLoading = false
      this.loadingText = '加载中...'
    },

    /**
     * 清除超时定时器
     */
    clearTimer() {
      if (this.timeoutTimer) {
        clearTimeout(this.timeoutTimer)
        this.timeoutTimer = null
      }
    },
  },
})
